import React from 'react';
import { getCountryFlag, getCountryName } from '../utils/countries';
import './CountryDisplay.css';

const CountryDisplay = ({ country, language }) => {
  if (!country) {
    return <span>-</span>;
  }

  const flag = getCountryFlag(country);
  const name = getCountryName(country, language);

  return (
    <div className="country-cell">
      {flag && (
        <span className="country-flag-emoji">
          {flag}
        </span>
      )}
      <span>{name}</span>
    </div>
  );
};

export default CountryDisplay;